// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x1Dd","title":"styles_title__2hy12"};